import Vue from 'vue'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import('../assets/style.scss');

/*
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
*/

Vue.use(
    BootstrapVue,
    {
        BNavItem: { activeClass: 'active'},
        BFormGroup: { labelClass: 'font-weight-bold' },
        BOverlay: { variant: 'white' },
        breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'xl2']
    }
);
Vue.use(BootstrapVueIcons);